// Modal2.tsx
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { getInstancesWithAdd, getInstancesWithAddglobal } from '../../accounts/troubleshoot/request/request';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useAuth } from '../../../auth';
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo';
const API_URL = process.env.REACT_APP_API_URL
type ID = undefined | null | number

interface Data {
  ip: string;
  ge?: string;
  le?: string;
  policy?: string;
}

interface Modal2Props {
  showModal: boolean;
  handleClose: () => void;
  setDatos: any
}

interface ApiData {
  ip: string;
  ge: number;
  le: number;
  policy: string;

}
type vrf = {
  vendor: string,
  vrf: string
  subscription: (string)
}
type vecino = {
  ip: string,
  desc: string
}
const Modal2: React.FC<Modal2Props> = ({ showModal, handleClose, setDatos }) => {
  /************************************llamadas a la API ********************************************** */
  const [ID, setID] = useState<ID>(undefined)

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  /*****************************************prueba text area */
  const [inputData, setInputData] = useState<string>('');
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const [Busqueda, setBusqueda] = useState("")
  const [listvrf, setlistvrff] = useState<vrf[]>([])
  const [vrfselect, setselectvrf] = useState<any>()
  const [vecino, setvecino] = useState<any>()
  const [listvecino, setlistvecino] = useState<vecino[]>([])
  const [configApplied, setConfigApplied] = useState(false);
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)


  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''

  }])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (FlagReg === true) {
          if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {

            if (tenant === 0) {
              const instancias = await getInstancesWithAdd(Id, 'Ctx.BGP.List', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
            else {
              const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.BGP.List', Type, nameregion);
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
          }
          else if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {

            if (tenant === 0) {
              const instancias = await getInstancesWithAdd(Id, 'Ctx.BGP.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
            else {
              const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.BGP.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              } else {
                setInstancia(instancias.data)
                setBusqueda(instancias.data[0].id)
              }
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [FlagReg, nameregion]
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(-1, 'Ctx.BGP.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(-1, tenant, 'Ctx.BGP.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }

          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id]
  )



  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Busqueda !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }
          if (type === "ctx") {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: Id
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/listVrf', body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
          }
          else if (type === "add") {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: Id
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/listVrf/add?tenantId=' + tenant, body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
            if (tenant === 0) {
              await axios.post(API_URL + '/v1/listVrf/add', body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
          }
        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Busqueda, Id])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Busqueda !== '' && vrfselect !== undefined && vrfselect !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[vrfselect]

          if (type === "ctx") {
            const body =
            {
              type: type,
              vrf: vrf
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor?tenantId=' + tenant, body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor', body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
          }
          else if (type === "add") {
            const body =
            {
              type: type,
              vrf: vrf
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor?tenantId=' + tenant, body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor', body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
          }
        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [vrfselect])




  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputData(event.target.value);
  };
  const cambiarstate = (e: any) => {
    setBusqueda(e.target.value)
  }
  const vrfseleccionada = (e: any) => {
    setselectvrf(e.target.value)
  }
  const vecinoseleccionado = (e: any) => {
    setvecino(e.target.value)
  }

  const [del, setdel] = useState(false)
  useEffect(() => {
    if (configApplied) {
      handleClose(); // Cierra el modal automáticamente
    }
  }, [configApplied]);


  /************************************************************************************ */
  const [swalInput, setSwalInput] = useState('');
  /************************************************************************************ */


  const handleCreateAndSendData = async () => {
    // Divide el texto en líneas y procesa cada línea
    const lines = inputData.split('\n');

    const apiDataArray: ApiData[] = lines.map((line) => {
      const trimmedLine = line.trim();
      // Verifica si la línea está vacía
      if (trimmedLine === '') {
        return null; // Ignora las líneas vacías
      }
      // Divide cada línea en valores
      const values = line.split(',');

      // Crea un objeto ApiData a partir de los valores
      const apiData: ApiData = {
        ip: values[0],
        ge: parseInt(values[1], 10),
        le: parseInt(values[2], 10),
        policy: values[3],

      };


      return apiData;
    }).filter(Boolean) as ApiData[];

    let type
    for (const x of Instancia) {
      if (Number(Busqueda) === x.id) {
        type = x.type
      }
    }

    const vrf = listvrf[vrfselect]

    const body = {
      type: type,
      vrf: vrf,
      neighbor: vecino,
      prefix: apiDataArray
    }
    //Se pregunta si se quiere aplicar la config 
    Swal.fire({
      width: '40%',
      position: 'center',
      icon: 'warning',
      title: "Are you sure you want to apply this configuration?",
      html: `
          <p>
          <strong>¡Attention!</strong> You are about to apply new configuration settings. Please verify that the following IP addresses belong to your network:</p>
          <br/>
          <strong style="color: red">This process may take a few seconds, please wait.</strong>
          <br/>
          <br/>
          <pre>Ip,ge,le,policy</pre>
          <pre>${apiDataArray.map(data => `${data.ip},${data.ge || ''},${data.le || ''},${data.policy || ''}`).join('\n')}</pre>
          <br/>
          `,
      input: 'text',
      inputPlaceholder: 'Enter "confirm" to continue...',
      inputValue: swalInput,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Add!',
      preConfirm: (value) => {
        if (!value.toLowerCase().includes('confirm')) {
          Swal.showValidationMessage('The input must contain the word "confirm"');
        } else {
          setSwalInput(value);
        }
      },
    }).then((result) => {

      if (result.isConfirmed) {
        setdel(true)
        if (tenant === 0) {
          axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/bulk_prefix', body).then(res => {
            setConfigApplied(true);
            /********************************************************************** */
            if (res.data.data && res.data.data.length !== 0) {
              // Si hay datos, pero también hay errores, mostrar un mensaje combinado
              if (res.data.error && res.data.error.length !== 0) {
                Swal.fire({
                  icon: 'warning',
                  title: 'An error occurred',
                  html: `<p>Some segments could not be added</p>
                          <pre>${res.data.error.map((data: any) => `${data.ip},${data.ge || ''},${data.le || ''},${data.policy || ''}`).join('\n')}</pre>
                          <p>The remaining segments have been added successfully.</p>`
                });
                setDatos(res.data.data);
                setdel(false);
              } else {
                // Solo hay datos, mostrar el mensaje de éxito
                Swal.fire(
                  'Added!',
                  'Your BGP Segments have been Added.',
                  'success'
                );
                setdel(false);
                setDatos(res.data.data);
              }
            } else if (res.data.error && res.data.error.length !== 0) {
              // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
              Swal.fire({
                icon: 'warning',
                title: 'An error occurred',
                html: `<p>Some segments could not be added</p>
                          <pre>${res.data.error.map((data: any) => `${data.ip},${data.ge || ''},${data.le || ''},${data.policy || ''}`).join('\n')}</pre>`
              });
            }
          })
          /**************************************************** */
        }
        else {
          axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/bulk_prefix?tenantId=' + tenant, body).then(res => {
            setConfigApplied(true);
            /********************************************************************** */
            if (res.data.data && res.data.data.length !== 0) {
              // Si hay datos, pero también hay errores, mostrar un mensaje combinado
              if (res.data.error && res.data.error.length !== 0) {
                Swal.fire({
                  icon: 'warning',
                  title: 'An error occurred',
                  html: `<p>Some segments could not be added</p>
                              <pre>${res.data.error.map((data: any) => `${data.ip},${data.ge || ''},${data.le || ''},${data.policy || ''}`).join('\n')}</pre>
                              <p>The remaining segments have been added successfully.</p>`
                });
                setDatos(res.data.data);
                setdel(false);
              } else {
                // Solo hay datos, mostrar el mensaje de éxito
                Swal.fire(
                  'Added!',
                  'Your BGP Segments have been Added.',
                  'success'
                );
                setdel(false);
                setDatos(res.data.data);
              }
            } else if (res.data.error && res.data.error.length !== 0) {
              // No hay datos, solo hay errores, mostrar el mensaje de advertencia con detalles de los errores
              Swal.fire({
                icon: 'warning',
                title: 'An error occurred',
                html: `<p>Some segments could not be added</p>
                              <pre>${res.data.error.map((data: any) => `${data.ip},${data.ge || ''},${data.le || ''},${data.policy || ''}`).join('\n')}</pre>`
              });
            }

          });
        }
      } else {
        Swal.fire({ title: "The configuration has not been applied!", icon: "info" });
      }
    });


    // Envía los datos a la API mediante Axios

  };


  useEffect(() => {
    return () => {
      setConfigApplied(false); // Restablece configApplied cuando el componente se desmonta
    };
  }, [configApplied]);


  useEffect(() => {
    if (Busqueda) {
      setselectvrf('')
      setlistvecino([])
      setvecino('')
    }
  }, [Busqueda])

  useEffect(() => {
    if (vrfselect) {
      setvecino('')

    }
  }, [vrfselect])

  const { currentUser } = useAuth()


  return (
    <div>
      <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex={-1} aria-labelledby="exampleModalLabel2" aria-hidden={!showModal}>
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel2"></h5>
              <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {/* Campos solicitud */}
              <h1 className='text-marino fw-bolder  mb-3 f-titulo fs-md'>Add BGP SegMent</h1>
              <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                <div className='text-info'>
                  Use this section to  <strong>Add</strong> BGP Segments.
                </div>
              </div>

              <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Instance</label>
              <select className="form-select text-center border-gray-300 f-parrafo" aria-label="Select example"
                onChange={cambiarstate} value={Busqueda}>
                {Instancia.length === 0 && <option disabled selected hidden>No data</option>}
                <option disabled selected hidden defaultValue={0}>Select an Instance </option>
                {Id !== 0 && Id !== -1 && Instancia.map((ins: any, x: any) =>
                  <option key={x} value={ins.id}>{ins.name}</option>
                )
                }
                {Id === -1 && Type === 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                  <option key={x} value={ins.id}>{ins.name}</option>
                )
                }
              </select>
              <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 flex-center">
                <div>
                  <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >VRF</label>
                  <select className="form-select text-center w-200px border-gray-300 f-parrafo" aria-label="Select example"
                    onChange={vrfseleccionada} value={vrfselect}>
                    {listvrf?.length === 0 ? <option key={'x'} className='text-danger bg-info' hidden>No VRF</option> : <option hidden>Select an VRF </option>}

                    {Busqueda !== '' && Id !== 0 && Id !== -1 && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                      <>
                        {!vrf.vrf && <option key={i} value={i}>Main</option>}
                        {vrf.vrf && <option key={i} value={i}>{vrf.vrf}</option>}
                      </>
                    )
                    }

                    {Busqueda !== '' && Id === -1 && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                      <>
                        {!vrf.vrf && <option key={i} value={i}>Main({vrf.subscriptions})</option>}
                        {vrf.vrf && <option key={i} value={i}>{vrf.vrf}({vrf.subscriptions})</option>}
                      </>
                    )
                    }
                  </select>
                </div>
                <div>
                  <label className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo' >Neighbor</label>
                  <select className="form-select text-center w-200px border-gray-300 f-parrafo" aria-label="Select example"
                    onChange={vecinoseleccionado} value={vecino}>

                    {listvecino?.length === 0 ? <option key={'c'} className='text-danger bg-info' hidden>No Neighbor</option> : <option hidden>Select an Neighbor </option>}

                    {Busqueda !== '' && Id !== 0 && Id !== -1 && listvecino.length !== 0 && listvecino.length !== undefined && listvecino.length !== null && listvecino?.map((nei: any, i: any) =>
                      <>
                        {nei.desc !== 'N/A' ? <option key={i} value={nei.ip}>{nei.ip} {nei.desc}</option> : <option key={i} value={nei.ip}>{nei.ip}</option>}
                      </>
                    )
                    }

                    {Busqueda !== '' && Id === -1 && Type === 'CloudGlobal' && listvecino.length !== 0 && listvecino.length !== undefined && listvecino.length !== null && listvecino?.map((nei: any, i) =>
                      <>
                        {nei.desc !== 'N/A' ? <option key={i} value={nei.ip}>{nei.ip} {nei.desc}</option> : <option key={i} value={nei.ip}>{nei.ip}</option>}

                      </>
                    )
                    }
                  </select>
                </div>
              </div>
              <div className='f-parrafo'>
                <p className='text-center fw-bolder'> Instructions</p>
                <p>Enter the required prefixes you want to add to the Neighbor, one per line in the following order and separated by a comma (,).</p>
                <br />
                <p className='text-center'><strong className='text-info'>Prefix,Greater Than,Less Than,Policy(permit or denny)</strong></p>
                <br />
                <p className='text-center'>
                  Example:
                  <br />
                  <strong>0.0.0.0/0,1,5,Permit</strong>
                </p>

                <p className='text-center'>If you prefer not to include the minimum and maximum intervals, follow the example:</p>

                <p className='text-center'><strong>0.0.0.0/0, , ,Permit</strong> </p>

                <label className='form-label fw-bolder text-dark fs-6 mb-0' htmlFor="descripcion">Prefixes</label>
                <textarea
                  value={inputData}
                  onChange={handleInputChange}
                  className="form-control form-control-solid border-primary border-active"
                  placeholder="
                    This is an example of bulk: 
                    0.0.0.0/0,2,3,permit
                    0.0.0.0/0,4,5,permit
                    0.0.0.0/0,6,8,permit
                    0.0.0.0/0,9,11,deny
                    0.0.0.0/0,13,16,deny"
                  required
                  rows={10}
                  cols={40}
                  id='Descripcion'
                />
              </div>
              <br />

              {currentUser?.is_demo !== true && <div className='row'>
                <div className='col'>
                  <button id='kt_sign_in_submit' onClick={handleCreateAndSendData}>{del ? 'Adding...' : 'Add'}{del && <span className='spinner-border spinner-border-sm align-middle ms-2'></span>}
                  </button>
                </div>
                <button
                  className='btn-cancel btn border border-pink text-pink f-parrafo'
                  style={{ width: '200px' }}
                  onClick={handleClose}

                >
                  Cancel
                </button>
              </div>}

              {currentUser?.is_demo === true && <div className="d-flex justify-content-center">
                <button onClick={() => setID(null)} type='submit' id='kt_sign_in_submit'
                >{del ? 'Adding...' : 'Add'}</button>

              </div>}

            </div>

          </div>
        </div>
      </div>
      {showModal && <div className='modal-backdrop fade show'></div>}
      {ID !== undefined && <DemoModal setID={setID} id={ID} />}

    </div>
  );
};

export default Modal2;